import React from "react";
import { Link } from "react-router-dom";

function Footer(){
    return(
        <>
            {/* Footer Start */}
    <footer className="main-footer">
        <div className="container">
            <div className="row">
                <div className="col-lg-4">
                    {/* About Footer Start */}
                    <div className="about-footer">
                        {/* Footer Logo Start */}
                        <div className="footer-logo">
                            <img src="/images/footer-logo.svg" alt="" />
                        </div>
                        {/* Footer Logo End */}

                        {/* About Footer Content Start */}
                        <div className="about-footer-content">
                            <p>Our clinic is committed to delivering compassionate care and advanced dental treatments for every patient.</p>
                         </div>
                         {/* About Footer Content End */}
                     </div>
                    {/* About Footer End */}
                </div>
                <div className="col-lg-3 col-md-4">
                    {/* Footer Quick Links Start */}
                    <div className="footer-links footer-quick-links">
                        <h3>quick links</h3>
                        <ul>                            
                            <li><Link to={`/`}>home</Link></li>
                            <li><Link to={`/about`}>about us</Link></li>
                            <li><Link to={`/service`}>services</Link></li>
                            <li><Link to={`/appointment`}>book apoointment</Link></li>
                        </ul>
                    </div>
                    {/* Footer Quick Links End */}
                </div>

                <div className="col-lg-3 col-md-4">
                    {/* Footer Social Links Start */}
                    <div className="footer-links footer-social-links">
                        <h3></h3>
                        <ul>                            
                            <li><Link to={`/photo`}>photos</Link></li>
                            <li><Link to={`/video`}>videos</Link></li>
                            <li><Link to={`/news`}>news</Link></li>
                            <li><Link to={`/contact`}>contact</Link></li>
                        </ul>
                    </div>
                    {/* Footer Social Links End */}
                </div>

                <div className="col-lg-2 col-md-4">
                    {/* Footer Contact Links Start */}
                    <div className="footer-links footer-contact-links">
                        <h3>contact us</h3>
                        <ul>                            
                            <li><a href="mailto:citydentalclinicpalus@gmail.com?subject=Dental Appointment Inquiry">citydentalclinicpalus@gmail.com</a></li>
                            <li><a href="tel:+917887919983"> 7887919983</a></li>
                        </ul>
                    </div>
                    {/* Footer Contact Links End */}
                </div>                
            </div>

            {/* Footer Copyright Section Start */}
            <div className="footer-copyright">
                <div className="row">
                    <div className="col-lg-12">
                        {/* Footer Copyright Start */}
                        <div className="footer-copyright-text">
                            <p>Copyright © 2026 All Rights Reserved.</p>
                            <p><a href="tel:+918805604252" className="footer-link">Designed & Developed by Shreyas Phase(8805604252)</a></p>
                        </div>
                        {/* Footer Copyright End */}
                    </div>
                </div>
            </div>
            {/* Footer Copyright Section End */}
        </div>
    </footer>
    {/* Footer End */}
        </>
    );
}

export default Footer;